import { DEV_MODE } from '../../../global/env';
import { DisposalBin, vdsEvent } from '../../events';
import { Logger } from '../../logger';
export class ElementDiscoveryController {
    constructor(_host, _eventType) {
        this._host = _host;
        this._eventType = _eventType;
        /* c8 ignore start */
        if (DEV_MODE) {
            this._logger = new Logger(_host, { owner: this });
        }
        /* c8 ignore stop */
        this._disconnectDisposal = new DisposalBin(_host, 
        /* c8 ignore next */
        DEV_MODE && { name: 'disconnectDisposal', owner: this });
        _host.addController({
            hostConnected: this._handleHostConnected.bind(this),
            hostDisconnected: this._handleHostDisconnected.bind(this)
        });
    }
    _handleHostConnected() {
        const event = vdsEvent(this._eventType, {
            bubbles: true,
            composed: true,
            detail: {
                element: this._host,
                onDisconnect: (callback) => {
                    this._disconnectDisposal.add(callback);
                }
            }
        });
        /* c8 ignore start */
        if (DEV_MODE) {
            this._logger
                .debugGroup('dispatched discovery event')
                .appendWithLabel('Event type', event.type)
                .appendWithLabel('Event', event)
                .end();
        }
        /* c8 ignore stop */
        this._host.dispatchEvent(event);
    }
    _handleHostDisconnected() {
        this._disconnectDisposal.empty();
    }
}
